import { useEffect, useState } from 'react';
import { SEO, NodeGraphBackground } from '@components/common';

export default function NotFoundPage() {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    // Redirect after 5 seconds
    const redirect = setTimeout(() => {
      window.location.href = '/';
    }, 5000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirect);
    };
  }, []);

  return (
    <>
      <SEO title="Page Not Found | The CISO Network" robots="noindex" />
      <div className="relative min-h-screen flex items-center justify-center bg-primary overflow-hidden">
        {/* Node-network background, centred scrim for the centred copy. */}
        <NodeGraphBackground focus="center" />

        {/* Content */}
        <div className="container-custom relative z-10 text-center">
          <div className="max-w-2xl mx-auto">
            <h1 className="text-7xl md:text-9xl font-heading font-bold text-primary-foreground mb-6">
              404
            </h1>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-primary-foreground mb-6">
              Page Not Found
            </h2>
            <p className="text-lg text-primary-foreground/70 mb-4 max-w-xl mx-auto">
              The Fractional CISO you're looking for doesn't exist here.
            </p>
            <p className="text-primary-foreground/50 mb-10">
              Redirecting you home in {countdown} seconds...
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
